import { api, getDevicesDetails } from '..'
import { TSnmpDeviceList } from 'shared/types'
import { uniqueArray } from 'utils/uniqueArray'
import { usePaginatedQuery } from 'hooks/usePaginatedQuery'

export type TSnmpDeviceListWithDetails = Awaited<
  ReturnType<typeof getSnmpDeviceList>
>

export const getSnmpDeviceList = async (params?: Record<string, string>) => {
  const { items, ...data } = await api
    .get<TSnmpDeviceList>('/v1/snmp/devices', {
      params,
    })
    .then(({ data }) => data)

  const deviceIds = uniqueArray(items.map(item => item.id))

  const details = await getDevicesDetails(deviceIds)

  const newItems = items.map(item => {
    const device = details.get(item.id)!
    return { ...item, ...device }
  })

  return { ...data, items: newItems }
}

export const snmpDeviceListQuery = (params?: Record<string, string>) => ({
  queryFn: () => getSnmpDeviceList(params),
  queryKey: ['snmpDevices', params],
})

export const useGetSnmpDevicesList = () =>
  usePaginatedQuery(snmpDeviceListQuery)
